module.exports = __webpack_public_path__ + "img/product-15.f69dcf36.jpg";